import styles from './ColorsMaterials.module.scss';
import { defineComponent, h } from 'vue';
import { Dialog, img } from '@phi/components';
import { switch_to_material } from '@frontend/colours_materials_appearance';

const plastic_png = 'img/plastic.png';
const porcelain_png = 'img/porcelain.png';
const enamel_png = 'img/enamel.png';
const nickel_png = 'img/nickel.png';
const obsidian_png = 'img/obsidian.png';
const gum_png = 'img/gum.png';
const glass_png = 'img/glass.png';

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    setup(props, { emit }) {
        return () => h(Dialog, {
            show: props.show,
            'onUpdate:show': x => emit('update:show', x),
            id: 'materialsModal',
            title: 'Materials',
            width: 'narrow',
            onClose: () => emit('update:show', false),
            confirm_label: null,
        }, () => h('div', { class: styles.wrapper }, [
            h('button', {
                type: 'button',
                class: ['btn', 'dark', styles.button],
                title: 'Plastic material',
                'data-toggle': 'popover',
                'data-html': true,
                'data-tippy-placement': 'top',
                'data-content': 'Set "Plastic" material for model surfaces.',
                onClick: () => switch_to_material('plastic'),
            }, img(plastic_png, 'plastic material', styles.image)),

            h('button', {
                type: 'button',
                class: ['btn', 'dark', styles.button],
                title: 'Pearl material',
                'data-toggle': 'popover',
                'data-html': true,
                'data-tippy-placement': 'top',
                'data-content': 'Set "Pearl" material for model surfaces.',
                onClick: () => switch_to_material('gum'),
            }, img(gum_png, 'gum material', styles.image)),

            h('button', {
                type: 'button',
                class: ['btn', 'dark', styles.button],
                title: 'Enamel',
                'data-toggle': 'popover',
                'data-html': true,
                'data-tippy-placement': 'top',
                'data-content': 'Set "Enamel" material for model surfaces.',
                onClick: () => switch_to_material('enamel'),
            }, img(enamel_png, 'enamel material', styles.image)),

            h('button', {
                type: 'button',
                class: ['btn', 'dark', styles.button],
                title: 'Nickel material',
                'data-toggle': 'popover',
                'data-html': true,
                'data-tippy-placement': 'top',
                'data-content': 'Set "Nickel" material for model surfaces.',
                onClick: () => switch_to_material('nickel'),
            }, img(nickel_png, 'nickel material', styles.image)),

            h('button', {
                type: 'button',
                class: ['btn', 'dark', styles.button],
                title: 'Obsidian material',
                'data-toggle': 'popover',
                'data-html': true,
                'data-tippy-placement': 'top',
                'data-content': 'Set "Obsidian" material for model surfaces.',
                onClick: () => switch_to_material('obsidian'),
            }, img(obsidian_png, 'obsidian material', styles.image)),

            h('button', {
                type: 'button',
                class: ['btn', 'dark', styles.button],
                title: 'Glass material',
                'data-toggle': 'popover',
                'data-html': true,
                'data-tippy-placement': 'top',
                'data-content': 'Set "Glass" material for model surfaces.',
                onClick: () => switch_to_material('glass'),
            }, img(glass_png, 'glass material', styles.image)),
        ]));
    }
});
